var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowGoBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.828 7 2.536 2.537L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 0 1 0 16H4v-2h9a6 6 0 0 0 0-12H5.828z",
    fill: "#DB233A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGoBack);
export default __webpack_public_path__ + "static/media/arrow-go-back.5f272112762b0429d2b2aa432b633173.svg";
export { ForwardRef as ReactComponent };